import { render, staticRenderFns } from "./RetourenVorgaenge.vue?vue&type=template&id=4276a76e&"
import script from "./RetourenVorgaenge.vue?vue&type=script&lang=js&"
export * from "./RetourenVorgaenge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports